// src/pages/Accounting/Receipts/components/OptionalConnections.tsx

import React from "react";
import { Smartphone, Inbox } from "lucide-react";
import { PALETTE } from "../constants";

interface OptionalConnectionsProps {
  onGetMobileApp: () => void;
  onConnectInbox: () => void;
}

export function OptionalConnections({
  onGetMobileApp,
  onConnectInbox,
}: OptionalConnectionsProps) {
  return (
    <>
      <div
        style={{
          fontSize: 11,
          color: PALETTE.ink4,
          fontWeight: 500,
          margin: "22px 0 14px",
          maxWidth: 720,
        }}
      >
        Optional: set up automatic capture for ongoing receipts
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: 0,
          maxWidth: 720,
          marginBottom: 24,
        }}
      >
        <ConnectionItem
          Icon={Smartphone}
          title="Snap on your phone"
          body="Novala mobile crops and uploads in one tap."
          ctaLabel="Get the iOS or Android app ▸"
          onCtaClick={onGetMobileApp}
          isFirst
        />
        <ConnectionItem
          Icon={Inbox}
          title="Auto-import from inbox"
          body="Connect Gmail or Outlook; Vela pulls vendor receipts in without forwarding."
          ctaLabel="Connect Gmail or Outlook ▸"
          onCtaClick={onConnectInbox}
          isLast
        />
      </div>
    </>
  );
}

interface ConnectionItemProps {
  Icon: React.ComponentType<{ size?: number; strokeWidth?: number }>;
  title: string;
  body: string;
  ctaLabel: string;
  onCtaClick: () => void;
  isFirst?: boolean;
  isLast?: boolean;
}

function ConnectionItem({
  Icon,
  title,
  body,
  ctaLabel,
  onCtaClick,
  isFirst,
  isLast,
}: ConnectionItemProps) {
  return (
    <div
      style={{
        padding: isFirst ? "0 24px 0 0" : isLast ? "0 0 0 24px" : "0 24px",
        borderRight: isLast ? "none" : `1px solid ${PALETTE.lineSoft}`,
        display: "flex",
        flexDirection: "column",
        gap: 6,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div
          style={{
            width: 24,
            height: 24,
            borderRadius: 6,
            background: "#fff",
            border: `1px solid ${PALETTE.line}`,
            color: PALETTE.ink2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon size={14} strokeWidth={2} />
        </div>
        <div>
          <h5
            style={{
              fontSize: 12.5,
              fontWeight: 700,
              margin: 0,
              color: PALETTE.ink,
            }}
          >
            {title}
          </h5>
          <p
            style={{
              fontSize: 11,
              color: PALETTE.ink3,
              margin: "2px 0 0",
              lineHeight: 1.5,
            }}
          >
            {body}
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={onCtaClick}
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: PALETTE.velaDeep,
          border: "none",
          background: "transparent",
          padding: 0,
          cursor: "pointer",
          alignSelf: "flex-start",
          borderBottom: `1px dotted ${PALETTE.velaDeep}`,
          marginTop: 4,
          fontFamily: "inherit",
        }}
      >
        {ctaLabel}
      </button>
    </div>
  );
}
